import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueGlobalVariable from 'vue-global-var';
var Promise = require('es6-promise').Promise;
require('es6-promise').polyfill();
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
/*import bFormSlider from 'vue-bootstrap-slider';*/
import { Icon } from 'leaflet';
import VueInputMask from "v-mask";
import Autocomplete from 'vuejs-auto-complete';
import VueScrollactive from 'vue-scrollactive';
import 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './assets/css/common.css';

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(LMap);
Vue.use(LTileLayer);
Vue.use(LMarker);
/*Vue.use(bFormSlider);*/
Vue.use(VueInputMask);
Vue.use(VueScrollactive);
Vue.component('autocomplete', Autocomplete);

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export const i18n = new VueI18n({
  locale: (localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fr'),
  fallbackLocale: 'fr',
  messages: loadLocaleMessages()
})

var isDev = false;
if (window.location.host.indexOf('localhost') >= 0 || window.location.host.indexOf('dev') >= 0 || window.location.host.indexOf('npr') >= 0) isDev = true;
Vue.use(VueGlobalVariable, {
  globals: {
    $apiUrl: 'https://' + (isDev ? 'svcapp-ooftop-plateforme-api-npr-001.azurewebsites.net' : 'api-v2-fw.ooftop.fr') + '/',//'http://127.0.0.1:8001/',//
    $apiOoftopUrl: 'https://' + (isDev ? 'dev-api' : 'api') + '.ooftop.fr/indicator/',//'http://127.0.0.1:8001/',//
  },
});

import axios from "axios";
Vue.mixin({
  data() {
    return {
      loading: false,
      currentCP: { type: '', target: '' },
      errorTxt: "",
      infos_cli: [],
      partner: { name: 'Ooftop', code: 'OOFT', ua_id: '', },
    }
  },
  methods: {
    changeLang: function () {
      var myarg = ((this.$i18n.locale == 'fr') ? 'en' : 'fr');
      localStorage.setItem('lang', myarg);
      this.$i18n.locale = myarg;
      this.get_infos_cli(1);
    },
    get_first_route() { var r = this.$route.path.replace('/', '').split('/'); return r[0]; },
    get_infos_cli(reload) {
      var p = this;
      var curUser = JSON.parse(localStorage.getItem('user'));
      if (reload) curUser = false;
      if (curUser) {
        p.infos_cli = curUser.infos_cli;
        if (p.infos_cli.iframed) document.getElementById("body").classList.add("iframed");
        if (p.infos_cli && p.infos_cli.societe) {
          if (document.getElementById("utilisateurActu")) document.getElementById('utilisateurActu').innerHTML = p.infos_cli.nom;
          if (document.getElementById("societeActu")) document.getElementById('societeActu').innerHTML = p.infos_cli.societe.label;
        }
      }
      else {
        var p = this;
        if (p.auth_header()) {
          axios.get(p.$apiUrl + "login/infos", { params: { auth: p.auth_header(), lang: i18n.locale } }).then(response => {
            if (response.data.error == 'notlogged') {
              p.logout();
            }
            else {
              var user = response.data;
              p.set_current_user(user);
              if (reload) window.location.reload();
            }
          }).catch(error => { });
        }
      }
    },
    maj_partner() {
      var curPartner = JSON.parse(localStorage.getItem('partner'));
      var curUser = JSON.parse(localStorage.getItem('user'));
      if (curPartner) {
        this.partner = curPartner;
        document.getElementById("body").classList.remove('loading');
        document.getElementById("body").classList.add(curPartner.code);
        document.getElementById("favicon").setAttribute("href", "/img/" + curPartner.code + "/favicon.ico");
        if (curPartner.code == "OOFT") {
          document.getElementById("body").classList.add("ARCA");
        }
        else {
          document.getElementById("body").classList.add("ND");
        }
        /*var UAScript = document.createElement("script");
            UAScript.type = "text/javascript";
            UAScript.setAttribute("async", "true");
            UAScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id="+curPartner.ua_id);
            document.documentElement.firstChild.appendChild(UAScript);
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        
        gtag('config', curPartner.ua_id);*/

        if (!this.$route.meta.title) this.$route.meta.title = curPartner.name;
        else this.$route.meta.title = this.$route.meta.title.replace('[SITE_NAME]', this.partner.name);
        if (this.$route.meta.presta && curUser) {
          this.infos_cli = curUser.infos_cli;
          let curPresta = this.infos_cli.menu.filter(p => (p.id == "menu_" + this.$route.meta.presta));
          if (curPresta && curPresta.length) {
            curPresta = curPresta[0];
            this.$route.meta.title = this.$route.meta.title.replace('[PRESTATION]', curPresta.title);
            if (this.$route.meta.btn) this.$route.meta.btn = this.$route.meta.btn.replace('[PRESTATION_BTN]', curPresta.btn);
            if (this.$route.meta.listing) this.$route.meta.listing = this.$route.meta.listing.replace('[PRESTATION_LISTING]', curPresta.listing);
          }
        }
        document.title = this.$route.meta.title;
      } else {
        this.get_partner();
      }
    },
    get_partner() {
      axios.get(this.$apiUrl + 'partners/' + window.location.hostname).then(response => {
        if (response.data.datas) {
          localStorage.setItem('partner', JSON.stringify(response.data.datas));
          this.maj_partner();
        } else {
          document.getElementById("body").classList.add('ARCA');
        }
      }).catch(error => { });
    },
    get_label_presta(prestation, v) {
      var p = this;
      axios.get(p.$apiUrl + "prestation/" + prestation, { params: { auth: p.auth_header(), lang: i18n.locale } }).then(response => {
        if (response.data.error == 'notlogged') {
          p.logout();
        }
        p.prestationTxt = response.data.label;
      }).catch(error => { });
    },
    auth_header() {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user && user.authdata) return { 'Authorization': 'Basic ' + user.authdata };
      else return false;
    },
    show_alert(variant, msg) {
      this.infosModal(variant, msg, 0, 'Information');
    },
    logout() {
      localStorage.removeItem('user');
      localStorage.clear();
      document.cookie.split(';').forEach(function (c) {
        document.cookie = c.trim().split('=')[0] + '=;' + 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      });
      if (this.$route.path != '/' && this.$route.path != '/login') window.location.reload();
    },
    is_logged_in() { return localStorage.getItem('user'); },
    get_current_user() { return JSON.parse(localStorage.getItem('user')); },
    set_current_user(user) {
      localStorage.setItem('user', JSON.stringify({ authdata: user.token, infos_cli: user.infos_cli }));
      this.set_cb_accepted();
    },
    is_cb_accepted() { return localStorage.getItem('cb_accepted'); },
    set_cb_accepted() {
      localStorage.setItem('cb_accepted', new Date().getTime());
    },
    commander(rt) {
      if (rt == "") rt = this.$route.path;
      rt = rt.toLowerCase().split('/');
      if (rt[0] == "" && rt[1]) rt = rt[1];
      else rt = rt[0];
      switch (rt) {
        case "evaluations":
          this.$router.push({ path: '/evaluations/ajout/' });
          break;
        case "evaluations_analyse":
          this.$router.push({ path: '/evaluations_analyse/ajout/' });
          break;
        case "documents_legaux":
          this.$router.push({ path: '/documents_legaux/ajout/' });
          break;
        case "expertises_immobilieres":
          this.$router.push({ path: '/expertises_immobilieres/ajout/' });
          break;
        case "avis_valeur":
        case "avis_valeurs":
          this.$router.push({ path: '/avis_valeurs/ajout/' });
          break;
        default:
          alert('Commander ' + rt);
          break;
      }
    },
    infosModal(cl, text, redirect, title) {
      var p = this;
      text = text.replace(/ - /g, ', ').replace(', ', '');
      if (title == this.$t('Champs incomplets')) var okTitle = this.$t('Je complète le formulaire');
      else var okTitle = "ok";
      var options = { title: title, okTitle: okTitle, size: 'sm', buttonSize: 'sm', okVariant: 'outline-gold border-2', headerClass: 'p-2 border-bottom-0', footerClass: 'p-2 border-top-0 fm', centered: true, cancelTitle: 'Fermer' };/* cl */
      this.$bvModal.msgBoxConfirm(p.$createElement('div', { domProps: { innerHTML: text } }), options).then(function () {
        if (cl == 'success' && typeof (redirect) != "undefined" && redirect != false) {
          p.$router.push({ path: '/' + redirect });
        }
      });
    },
    get_pays() {
      axios.get(this.$apiUrl + 'api_externe/pays?auth=' + JSON.stringify(this.auth_header())).then(response => {
        if (response.data.datas) {
          var pays = [];
          response.data.datas.forEach(function (item) {
            pays.push({ value: item.CODE, text: item.LABEL });
          });
          this.pays = pays;
        } else {
          this.show_alert("warning", this.$t("Pas de pays disponible"));
        }
      }).catch(error => { });
    },
    get_regions() {
      axios.get(this.$apiUrl + 'api_externe/region?auth=' + JSON.stringify(this.auth_header())).then(response => {
        if (response.data.datas) {
          var regions = [];
          response.data.datas.forEach(function (item) {
            regions.push({ value: item.CODE, text: item.LABEL });
          });
          this.regions = regions;
        } else {
          this.show_alert("warning", "Pas de regions disponible");
        }
      }).catch(error => { });
    },
    get_departements() {
      axios.get(this.$apiUrl + 'api_externe/departement?auth=' + JSON.stringify(this.auth_header())).then(response => {
        if (response.data.datas) {
          var departements = [];
          response.data.datas.forEach(function (item) {
            departements.push({ value: item.CODE, text: item.LABEL });
          });
          this.departements = departements;
        } else {
          this.show_alert("warning", this.$t("Pas de departements disponible"));
        }
      }).catch(error => { });
    },
    get_categories_juridiques() {
      axios.get(this.$apiUrl + 'api_externe/categorie_juridique?auth=' + JSON.stringify(this.auth_header())).then(response => {
        if (response.data.datas) {
          var categorie_juridique = [];
          response.data.datas.forEach(function (item) {
            categorie_juridique.push({ value: item.ID, text: item.LABEL });
          });
          this.categorie_juridique = categorie_juridique;
        } else {
          this.show_alert("warning", this.$t("Pas de departements disponible"));
        }
      }).catch(error => { });
    },
    formatFieldErrorName(cn) {
      cn = cn.replace('_', ' ');
      if (cn == "bien type" || cn == "forms type_bien") cn = this.$t("Type de bien");
      if (cn == "type") cn = this.$t("Type de propriétaire");
      if (cn == "type hab") cn = this.$t("Type de bien (Appt, maison ...)");
      if (cn == "lat") cn = this.$t("Adresse");
      if (cn == "surface") cn = this.$t("Superficie du bien");
      if (cn == "AAAA-MM ou AAAA") cn = this.$t("Date d'acquisition");
      if (cn == "montant-acquisition") cn = this.$t("Montant d'acquisition");
      if (cn != 'lng') this.errorTxt += " - " + (cn.charAt(0).toUpperCase() + cn.slice(1)) + "";
      return true;
    },
    check_form(div) {//return 0;
      var $ = window.jQuery = require('jquery');
      var error = 0;
      var p = this;
      var lastTestRadio = "";
      p.errorTxt = "";
      $(div + " .custom-control-input:required," + div + " .custom-checkbox:required," + div + " .btn-group-toggle input:required").each(function () {
        var radioTest = $(this);
        if (lastTestRadio != $(this).attr('name')) {
          lastTestRadio = $(this).attr('name');
          if (!$(div + " .custom-control-input[name='" + lastTestRadio + "']:checked," + div + " .custom-checkbox[name='" + lastTestRadio + "']:checked," + div + " .btn-group-toggle input[name='" + lastTestRadio + "']:checked").length) {
            error++;
            var cn = lastTestRadio;
            p.formatFieldErrorName(cn);
            radioTest.closest('div:not(.custom-control)').addClass('error');
            $(div + " .custom-control-input[name='" + lastTestRadio + "']," + div + " .custom-checkbox[name='" + lastTestRadio + "']," + div + " .btn-group-toggle input[name='" + lastTestRadio + "']").on("change", function () {
              $(this).closest('div:not(.custom-control)').removeClass("error");
            });
          }
        };
      })
      $(div + " .form-control:required," + div + " .form-control.required," + div + " #demande .form-control").each(function () {
        if ($(this).hasClass('libre') || $(this).hasClass('de') || $(this).hasClass('a')) {
          var cdLDP = $(this).closest('div:not(.coproprieteLots)');
          if (cdLDP.find(".form-control.libre:required").val() != "") {
            // Tout est ok
          } else {
            var errorLDP = 0;
            cdLDP.find(".coproprieteLots .form-control:required").each(function () {
              if ($(this).val() == "") {
                errorLDP++;
              }
            });
            if (errorLDP) {
              error++;
              p.formatFieldErrorName(p.$t("Plage / Références cadastrales"));
              cdLDP.find(".form-control:required").addClass('error');
            }
          }
        } else {
          if (!$(this).val()) {
            error++;
            var cn = $(this).attr('placeholder');
            if (typeof (cn) != "undefined" && cn != "") { cn = cn.split(' ('); cn = cn[0]; }
            else cn = $(this).attr('id');
            if (!cn) cn = $(this).closest('.autocomplete').attr('id');
            p.formatFieldErrorName(cn);
            $(this).addClass('error');
            $(this).closest('.autocomplete').addClass('error');
            $(this).on('focus', function () { $(this).closest('.autocomplete').removeClass('error'); });
          }
        }
      });
      $(div + " .form-control.stateError").each(function () {
        error++;
        var cn = $(this).attr('placeholder');
        if (typeof (cn) != "undefined" && cn != "") { cn = cn.split(' ('); cn = cn[0]; }
        else cn = $(this).attr('id');
        p.formatFieldErrorName(cn);
        $(this).addClass('error');
        $(this).closest('.autocomplete').addClass('error');
        $(this).on('focus', function () { $(this).closest('.autocomplete').removeClass('error'); });
      });
      $(div + " .form-control.alphaCheck").each(function () {
        $(this).val(p.remove_accents($(this).val()));
        if ($(this).val() != "" && ($(this).val().match(/\d+/g) != null || $(this).val() != p.remove_accents($(this).val()))) {
          error++;
          var cn = $(this).attr('placeholder');
          if (typeof (cn) != "undefined" && cn != "") { cn = cn.split(' ('); cn = cn[0]; }
          else cn = $(this).attr('id');
          p.formatFieldErrorName(cn);
          $(this).addClass('error');
        }
      });
      $(div + " .form-control.alphaNumCheck").each(function () {
        $(this).val(p.remove_accents($(this).val()).replace(/\s/g, ''));
      });
      $(div + " .form-control.numCheck").each(function () {
        $(this).val($(this).val().replace(' ', '').replace(' ', '').replace(' ', ''));
        if ($(this).val() != "" && !$.isNumeric($(this).val())) {
          error++;
          var cn = $(this).attr('placeholder');
          if (typeof (cn) != "undefined" && cn != "") { cn = cn.split(' ('); cn = cn[0]; }
          else cn = $(this).attr('id');
          p.formatFieldErrorName(cn);
          $(this).addClass('error');
        }
      });
      $(".form-control.error").on('focus', function () { $(this).removeClass('error'); })
      return error;
    },
    ajouter_form(f, t, c) {
      if (c && this.check_form(".ajout form")) alert(this.$t('Merci de remplir correctement tous les formulaires ouvert avant de continuer'));
      else {
        switch (t) {
          case 'pp':
            f.push({ civilite: '', nom: '', nom_jf: '', prenom: '', prenom2: '', date_naissance: '', ville_naissance: '', cp_naissance: '', ci_naissance: '', pays_naissance: '99100' });
            break;
          case 'pm':
            f.push({ type: 'I', siren: '', denomination: '', categorie_juridique: '', adresse: '', code_postal: '', ville: '', code_postal_rcs: '', ville_rcs: '', pays: '99100' });
            break;
          case 'im':
            this.forms.options.options = [];
            this.forms.zn = [];
            if (this.forms.im == []) this.infosModal('warning', this.$t('En saisissant un immeuble: la zone géographique ci-dessous sera supprimée.'), 0, 'Informations');
            f.push({ ref_cad: [{ prefixe: '', section: '', parcelle: '' }], copropriete: 0, copropriete_lot: { libre: '', plage: [{ de: '', a: '' }] }, copropriete_volume: { libre: '', plage: [{ de: '', a: '' }] }, adresse: '', code_postal: '', ville: '', code_insee: '', ajouter_plage: 0 });
            break;
          case 'zn':
            this.forms.im = [];
            /*if(this.forms.zn==[])this.infosModal('warning','En saisissant une zone: vous ne pourrez plus saisir d\'immeuble',0,'Informations');*/
            f.push({ type: 'C', departement: '', region: '', code_postal: '', ville: '', code_insee: '' });
            break;
          case 'docs':
            f.push({ type: this.prestation, date_publication: '', ref_enliassement: '', code_postal: '', ville: '', code_insee: '' });
            break;
          case 'ref_cad':
            f.push({ prefixe: '', parcelle: '', section: '' });
            break;
          case 'lot_plage':
            f.push({ de: '', a: '' });
            break;
          case 'ref_cad_all':
            f.push({ prefixe: '', parcelle: '', section: '', contenance: '', n_lot: '' });
            break;
          case 'pjs':
            f.push({ url: '', name: '', file: '' });
            break;
        }
      }
    },
    delete_form(f, i) { f.splice(i, 1); this.cpc(); },
    convert_expert(id, demande_email, rapport_email) {
      var p = this;
      axios.get(this.$apiUrl + "demandes/convert_expert/" + id + "?demande_email=" + demande_email + "&rapport_email=" + rapport_email + "&auth=" + JSON.stringify(this.auth_header())).then(function (response) {
        if (response.data.error == 'notlogged') {
          p.logout();
        }
        if (response.data.error != "") {
          alert(response.data.error);
        }
        if (response.data.success) {
          p.infosModal('success', response.data.success, 'evaluations_analyse', 'Confirmation');
        }
      });
    },
    send_file(fs, f, type) {
      for (var i = 0; i < fs.length; i++) {
        let formData = new FormData();
        formData.append('file', fs[i]);
        axios.post(this.$apiUrl + "demandes/uploadfile/" + type + "?auth=" + JSON.stringify(this.auth_header()), formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          if (response.data.error == 'notlogged') {
            this.logout();
          }
          if (response.data.error != "") {
            alert(response.data.error);
          }
          if (response.data.datas) {
            f.push(response.data.datas);
          }
        }).catch(function () {
        });
      }
    },
    check_price(type, f) {
      this.currentCP = { type: type, target: f };
      var p = this;
      window.setTimeout(function () {
        let formData = new FormData();
        formData.append('datas', JSON.stringify(f));
        axios.post(p.$apiUrl + "demandes/panier/" + type + "?lang=" + i18n.locale + "&auth=" + JSON.stringify(p.auth_header()), formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          if (response.data.error == 'notlogged') {
            p.logout();
          }
          if (response.data.datas) {
            p.panier = response.data.datas;
          } else {
          }
        }).catch(error => { });
      }, 50)
    },
    cpc() {
      this.check_price(this.currentCP.type, this.currentCP.target);
    },
    getDataCPN(obj) { if (obj.length < 3) return false; return this.$apiUrl + "api_externe/commune?auth=" + JSON.stringify(this.auth_header()) + "&parameters[code_postal]=" + obj + ""; },
    getDataCPNV(obj) { if (obj.length < 3) return false; return this.$apiUrl + "api_externe/commune?auth=" + JSON.stringify(this.auth_header()) + "&parameters[nom_commune]=" + obj + ""; },
    getDataSIREN(obj) { if (obj.length < 7) return false; return this.$apiUrl + "api_externe/info_ste?auth=" + JSON.stringify(this.auth_header()) + "&parameters[champs][]=siret&parameters[champs][]=label&parameters[champs][]=name&parameters[champs][]=mnemonique&parameters[champs][]=address1&parameters[champs][]=address2&parameters[champs][]=cp&parameters[champs][]=ville&parameters[champs][]=cprcs&parameters[champs][]=villercs&parameters[champs][]=pays&parameters[champs][]=categorie_juridique&parameters[SIREN]=" + obj.replace(/\s/g, '') + ""; },
    resultDataCPN(response) { return response.datas; },
    resultDataSIREN(response) { return [response.datas.all]; },
    formattedDataCPN(result) { if (result) return result.LABEL + " (" + result.CODE_POSTAL + ")"; },
    formattedDataSIREN(result) { if (result) return result.label; },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    remove_accents(strAccents) {
      var strAccents = strAccents.split('');
      var strAccentsOut = new Array();
      var strAccentsLen = strAccents.length;
      var accents = "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else
          strAccentsOut[y] = strAccents[y];
      }
      strAccentsOut = strAccentsOut.join('');

      return strAccentsOut.replace(/[^a-z0-9\s]/gi, '').replace(/[-\s]/g, '_').replace(/[\u0300-\u036f]/gi, '');
    },
    includes(container, value) {
      var returnValue = false;
      var pos = container.indexOf(value);
      if (pos >= 0) {
        returnValue = true;
      }
      return returnValue;
    },
    format_number(num, pourcent = false, multi = 10) {
      if (!pourcent) return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      else {
        num = (Math.round(num * multi) / multi);
        return num;
        num = num.toString().split(".");
        num[0] = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return num.join(".");
      }
    },
    get_notifications() {
      var p = this;
      if (p.auth_header()) {
        axios.get(p.$apiUrl + "demandes/nb/365", { params: { auth: p.auth_header() } }).then(response => {
          if (response.data.error == 'notlogged') {
            p.logout();
          }
          for (var i = 0; i < response.data.length; i++) {
            document.getElementById('menu_' + response.data[i].type + '_badge').innerHTML = response.data[i].nb;
          }
        }).catch(error => { });
      }
    }
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
